<template>
	<div class="h-[10px] rounded-full bg-blue-50 overflow-hidden w-full">
		<div
			class="h-full rounded-full bg-gradient-to-r from-[#00B4DB] to-[#0083FF] transition-all duration-500 ease-in-out"
			:style="{ width: calculatedWidth + '%' }"
		></div>
	</div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

export default defineComponent({
	name: "DjProgressBar",
	props: {
		level: {
			type: [String, Number],
			required: true,
		},
		max: {
			type: Number,
			default: 5,
		},
	},
	setup(props) {
		// Automatically calculates the percentage width based on the level and max value
		const calculatedWidth = computed(() => {
			return (Number(props.level) / props.max) * 100;
		});

		return {
			calculatedWidth,
		};
	},
});
</script>
